 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"AboutProjectEditForm":"AboutProjectEditForm","Activity":"Activity","AdminListOfUsers~ListOrganizationsView~StudentsList":"AdminListOfUsers~ListOrganizationsView~StudentsList","AdminListOfUsers":"AdminListOfUsers","ListOrganizationsView":"ListOrganizationsView","StudentsList":"StudentsList","AllEvents":"AllEvents","AllNews":"AllNews","Auth":"Auth","AuthUser":"AuthUser","BuildInfo":"BuildInfo","ChangeRole":"ChangeRole","DevelopmentMoodlePage":"DevelopmentMoodlePage","DevelopmentPage":"DevelopmentPage","EmailConfirmation":"EmailConfirmation","ErrorAuthLkPage":"ErrorAuthLkPage","ErrorPage":"ErrorPage","EventsViewer~NewsViewer~OrganizationViewer":"EventsViewer~NewsViewer~OrganizationViewer","EventsViewer":"EventsViewer","NewsViewer":"NewsViewer","OrganizationViewer~Portfolio~Profile":"OrganizationViewer~Portfolio~Profile","OrganizationViewer":"OrganizationViewer","FakeAuthRoute":"FakeAuthRoute","Feed":"Feed","MainPage":"MainPage","Notifications":"Notifications","Portfolio":"Portfolio","Profile":"Profile","PasswordRecovery":"PasswordRecovery","ProjectAddRoute":"ProjectAddRoute","ProjectPageRoute":"ProjectPageRoute","ProjectsListRoute":"ProjectsListRoute","Registration":"Registration","ServerLogs":"ServerLogs","Sessions":"Sessions","StudentsETUList":"StudentsETUList"}[chunkId]||chunkId) + "." + {"AboutProjectEditForm":"3c49c03c","Activity":"48f1d45e","AdminListOfUsers~ListOrganizationsView~StudentsList":"8b4dc261","AdminListOfUsers":"90f6a701","ListOrganizationsView":"d6402e93","StudentsList":"f7f929e9","AllEvents":"85b0d523","AllNews":"99d3b2ec","Auth":"8f5f2db2","AuthUser":"c075d4d6","BuildInfo":"13835bc7","ChangeRole":"fc8d137e","DevelopmentMoodlePage":"459f772d","DevelopmentPage":"0dfcaaa6","EmailConfirmation":"8bc5c3bd","ErrorAuthLkPage":"ca3a93ad","ErrorPage":"77d36e02","EventsViewer~NewsViewer~OrganizationViewer":"b7681080","EventsViewer":"0924bd50","NewsViewer":"1ff39fd7","OrganizationViewer~Portfolio~Profile":"6937eedb","OrganizationViewer":"2b2a72f5","FakeAuthRoute":"038fd36c","Feed":"8bbf2596","MainPage":"6477c5f0","Notifications":"65a66147","Portfolio":"4caf5049","Profile":"06c856db","PasswordRecovery":"202f822d","ProjectAddRoute":"8f16d46e","ProjectPageRoute":"0e5ca52f","ProjectsListRoute":"9ad388b8","Registration":"2c8f493b","ServerLogs":"9c947a4e","Sessions":"5c60d4e5","StudentsETUList":"794e34f7"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"AboutProjectEditForm":1,"Activity":1,"AdminListOfUsers":1,"ListOrganizationsView":1,"StudentsList":1,"AllEvents":1,"AllNews":1,"Auth":1,"AuthUser":1,"BuildInfo":1,"DevelopmentMoodlePage":1,"DevelopmentPage":1,"EmailConfirmation":1,"ErrorAuthLkPage":1,"ErrorPage":1,"EventsViewer~NewsViewer~OrganizationViewer":1,"EventsViewer":1,"NewsViewer":1,"OrganizationViewer~Portfolio~Profile":1,"OrganizationViewer":1,"Feed":1,"MainPage":1,"Notifications":1,"Portfolio":1,"Profile":1,"PasswordRecovery":1,"ProjectPageRoute":1,"ProjectsListRoute":1,"Registration":1,"ServerLogs":1,"Sessions":1,"StudentsETUList":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"AboutProjectEditForm":"AboutProjectEditForm","Activity":"Activity","AdminListOfUsers~ListOrganizationsView~StudentsList":"AdminListOfUsers~ListOrganizationsView~StudentsList","AdminListOfUsers":"AdminListOfUsers","ListOrganizationsView":"ListOrganizationsView","StudentsList":"StudentsList","AllEvents":"AllEvents","AllNews":"AllNews","Auth":"Auth","AuthUser":"AuthUser","BuildInfo":"BuildInfo","ChangeRole":"ChangeRole","DevelopmentMoodlePage":"DevelopmentMoodlePage","DevelopmentPage":"DevelopmentPage","EmailConfirmation":"EmailConfirmation","ErrorAuthLkPage":"ErrorAuthLkPage","ErrorPage":"ErrorPage","EventsViewer~NewsViewer~OrganizationViewer":"EventsViewer~NewsViewer~OrganizationViewer","EventsViewer":"EventsViewer","NewsViewer":"NewsViewer","OrganizationViewer~Portfolio~Profile":"OrganizationViewer~Portfolio~Profile","OrganizationViewer":"OrganizationViewer","FakeAuthRoute":"FakeAuthRoute","Feed":"Feed","MainPage":"MainPage","Notifications":"Notifications","Portfolio":"Portfolio","Profile":"Profile","PasswordRecovery":"PasswordRecovery","ProjectAddRoute":"ProjectAddRoute","ProjectPageRoute":"ProjectPageRoute","ProjectsListRoute":"ProjectsListRoute","Registration":"Registration","ServerLogs":"ServerLogs","Sessions":"Sessions","StudentsETUList":"StudentsETUList"}[chunkId]||chunkId) + "." + {"AboutProjectEditForm":"403bcb0b","Activity":"01d149d1","AdminListOfUsers~ListOrganizationsView~StudentsList":"31d6cfe0","AdminListOfUsers":"7598675d","ListOrganizationsView":"4a006f53","StudentsList":"96a1c4ec","AllEvents":"123c1d4f","AllNews":"3085086a","Auth":"49ad8752","AuthUser":"4e3ead3b","BuildInfo":"a0bf327a","ChangeRole":"31d6cfe0","DevelopmentMoodlePage":"291ebc9f","DevelopmentPage":"af8596e1","EmailConfirmation":"57acd446","ErrorAuthLkPage":"7e18ec5c","ErrorPage":"27342081","EventsViewer~NewsViewer~OrganizationViewer":"8dd86832","EventsViewer":"401d3541","NewsViewer":"401d3541","OrganizationViewer~Portfolio~Profile":"e87c2e4a","OrganizationViewer":"d3d43f4a","FakeAuthRoute":"31d6cfe0","Feed":"864f5228","MainPage":"6224819c","Notifications":"0446b60e","Portfolio":"53e3a666","Profile":"cdbd749e","PasswordRecovery":"9e40d74e","ProjectAddRoute":"31d6cfe0","ProjectPageRoute":"2ded1952","ProjectsListRoute":"a9b99f2e","Registration":"504b9309","ServerLogs":"ea0e78aa","Sessions":"f4959a60","StudentsETUList":"4c1b2829"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/etuclasses/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
